export default __webpack_public_path__ + "static/media/SP.1ba7e2e4.svg";